import { useState, useEffect } from "react";
import { getDoc, doc } from "firebase/firestore/lite"; // Use methods from Firestore Lite
import { db } from "../firestore/firebase.utilities"; 

function useFirestoreDocument(collectionName, documentId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, `${collectionName}/${documentId}`); // Construct the document reference
        const docSnapshot = await getDoc(docRef); // Use getDoc() from Firestore Lite
        if (docSnapshot.exists()) {
          setData(docSnapshot.data());
          setLoading(false);
        } else {
          setError(new Error("Document not found"));
          setLoading(false);
        }
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [collectionName, documentId]);

  return { data, loading, error };
}

export default useFirestoreDocument;
